import React, { useEffect } from "react";
import AOS from "aos";

// Material-UI Components
import {
  Box,
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";

// Material-UI Icons
import ArrowDownwardRoundedIcon from "@mui/icons-material/ArrowDownwardRounded";

const wocTimeline = [
  { name: "Registration", value: "28th December 2024 to 2nd January 2025" },
  { name: "Development Phase Start", value: "4th January 2025 onwards" },
  { name: "Mid-Evaluation", value: "19th - 20th January 2025" },
  { name: "Presentation", value: "12th February 2025" },
  { name: "Results", value: "13th February 2025" },
];

const wocFAQs = [
  {
    question: "Will you suggest some sources for making a project?",
    answer:
      "💡 You already have access to some raw resources through the project documents. More resources and guidelines will be shared through the project WhatsApp groups on a timely basis. Rest, the participants would have to create by employing their technical and creative skills.",
  },
  {
    question:
      "Are you going to teach us or we have to learn by watching videos?",
    answer:
      "💡 We will share the resources that can include our segregated document, online free resources, or official documents. We try to provide resources in English and Hindi so that language doesn't hinder your learning journey. The mentors would be present throughout the WoC, and you can ask your doubts in case you are unable to clearly understand the concept from the shared resources.",
  },
  {
    question:
      "Will I be allowed to work on different projects at the same time?",
    answer:
      "💡 Yes, you can push yourself to learn from various resources related to different projects provided by us. But only the project allotted to you will be considered for ✨ WoC 7.0, wherein you’ll have mentors to guide you.",
  },
  {
    question:
      "How does this project help us in the future? What can we expect from this project?",
    answer:
      "💡 The projects are designed in such a way that it teaches you a complete new tech-stack from scratch. The tools and technologies taught in the projects are all widely used in the industries and would help you during your Internship or Job. If you complete your project and deploy it you can add it to your resume.",
  },
  {
    question: "Can I switch to a different project mid-way?",
    answer:
      "💡 Once you are allocated a project, you are expected to stick with it. However, if you face challenges, feel free to reach out to your mentor for guidance. Changing projects mid-way is not allowed.",
  },
  {
    question:
      "If I want to do a project different from the one allotted to me after finishing the allotted project (as this event is for learning purpose), can I do so?",
    answer:
      "💡 We can assure you that the time duration suggested for each project is just the perfect for you to master the concerned tech. Completing the same in less days is not something advisable as it would highly degrade your quality of learning.",
  },
  {
    question: "If I work on 2 projects, can I submit both of them?",
    answer:
      "💡 In Winter of Code, You’ll be allocated only 1 project and you are supposed to work on that for the entire duration of ✨ WoC. You can learn and develop other projects as well but that will not be a part of your ✨ WoC.",
  },
  {
    question: "I'm from b.tech 1st year. Why do I have only 2 choices here?",
    answer:
      "💡 It is suggested that B.Tech first year students start from basic projects then work their way up to complex projects and tech stacks. Although people interested are encouraged to learn from various sources provided by MSTC, if some individual wants to work on a project that is not meant for first-years under ✨ WoC 7.0, they can connect with any mentor to get their category changed.",
  },
  {
    question:
      "I don't have an IT background and know just the primitives of programming languages. Would I be able to work on this project? (especially for MSc/MTech students)",
    answer:
      "💡 Every project would cover things right from zero level to the advanced concepts. We don’t expect you having a good grip on the programming language used. Still, if you feel you need more assistance, feel free to reach out to your mentors and they’ll help you with some additional resources on things.",
  },
  {
    question: "What happens if I cannot complete my project?",
    answer:
      "💡 If you are unable to complete your project, don't worry. The main objective of this program is learning, and even if your project is not finished, you will still gain valuable knowledge. You will not be penalized for incomplete work, and your mentors will provide support throughout the process to help you improve and learn.",
  },
  {
    question: "Do we get a participation certificate?",
    answer:
      "💡 Yes, all participants who complete their project will get participation certificates.",
  },
  {
    question: "How are projects given, in group or single?",
    answer:
      "💡 You are expected to work individually on your allotted project.",
  },
  {
    question: "Is it required to update everyday?",
    answer:
      "💡 No, mode of submission and evaluation will be discussed by your respective mentors.",
  },
  {
    question:
      "I know nothing about the tech in my project. Will you start from the very basics?",
    answer: "💡 Yes, indeed.",
  },
  {
    question: "What will be the deadline for submission of the project?",
    answer: "💡 11th February, 2025",
  },
];

export default function Clarifications() {
  useEffect(() => {
    AOS.init({
      duration: 700,
      easing: "ease-in-out",
      once: true,
    });
  }, []);

  return (
    <Box
      data-aos="fade-up"
      sx={{
        padding: { xs: "16px", sm: "32px", md: "48px" },
        // bgcolor: "#023047",
        color: "white",
        minHeight: "100vh",
      }}
    >
      <Typography
        sx={{
          fontSize: { xs: "1.2rem", sm: "1.8rem", md: "2.5rem", lg: "3rem" },
          textAlign: "center",
          fontWeight: "bold",
          mb: { xs: 0, sm: 2, md: 3, lg: 3, xl: 3 },
          color: "white",
        }}
      >
        🌟 WoC 7.0 Clarifications 🌟
      </Typography>

      <Box
        sx={{
          bgcolor: "rgb(255, 255, 255, 0.1)",
          borderRadius: "10px",
          color: "black",
          my: { xs: 3, sm: 4, md: 6, lg: 8, xl: 10 },
          p: { xs: 2.5, sm: 3, md: 4, lg: 6, xl: 4 },
        }}
      >
        <Grid container spacing={2}>
          {wocFAQs.map((faq, index) => (
            <Grid key={index} item xs={12} sm={12} padding={0} margin={0}>
              <Accordion
                sx={{
                  borderRadius: "160px", // Adjust border-radius here
                  boxShadow: 2, // Optional: Add some shadow for a more lifted effect
                  "&:before": { display: "none" }, // Removes the default border-top line on the Accordion
                }}
              >
                <AccordionSummary
                  expandIcon={
                    <ArrowDownwardRoundedIcon sx={{ color: "#023047" }} />
                  }
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    sx={{
                      px: 1,
                      mr: 2,
                      bgcolor: "#023047",
                      color: "#EFEAE3",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "fit-content",
                      height: "fit-content",
                      borderRadius: "6px",
                    }}
                  >
                    Q
                  </Typography>
                  <Typography variant="body1" fontWeight="bold">
                    {faq.question}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ display: "flex" }}>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    sx={{
                      px: 1,
                      mr: 2,
                      bgcolor: "#023047",
                      color: "#EFEAE3",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "fit-content",
                      height: "fit-content",
                      borderRadius: "6px",
                    }}
                  >
                    A
                  </Typography>
                  <Typography>{faq.answer}</Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
}
